import { Paper, Stack, Typography } from '@mui/material'
import React from 'react'
import { KsefIncomingStatusWidget } from '../../KsefIncoming'
import { KsefOutgoingStatusWidget } from '../../KsefOutgoing'

const Dashboard = () => {
    return (
        <Stack spacing={3}>
            <Paper sx={{ p: 3 }}>
                <Typography variant="h4">Dashboard</Typography>
                <Typography>Witaj w panelu zarządzania!</Typography>
            </Paper>

            <KsefIncomingStatusWidget pollingIntervalMs={30000} />

            <KsefOutgoingStatusWidget pollingIntervalMs={30000} />
        </Stack>
    )
}

export default Dashboard